<section class="section-b-space">
  <!-- <div class="container"> -->
  <!-- <div class="container-fluid">
    <div class="row">
      <div class="col-lg-{{left_menu}}">
        <div class="account-sidebar" (click)="ToggleDashboard()">
          <a href="javascript:void(0)" class="popup-btn">My Account</a>
        </div>
        <div class="dashboard-left" [class.open]="openDashboard">
          <div class="collection-mobile-back" (click)="ToggleDashboard()">
            <span class="filter-back">
              <i class="fa fa-angle-left" aria-hidden="true"></i> Back
            </span>
          </div>
          <div class="block-content-custom" [class.collapsed]="expand_menu">
            <i class="fa-solid fa-bars d-flex justify-center" aria-hidden="true" (click)="setMenu()"></i>

            <app-dashboard-menu-list [collapsed]="expand_menu"></app-dashboard-menu-list>
          </div>
        </div>
      </div>
      <div class="col-lg-{{right_body}}">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div> -->

  <div class="container-fluid">
    <!-- <p (click)="setFullScreen()" class="text-end"> full screen</p> -->
    <!-- <div class="row">
      <div class="col-lg-11"></div>
      <div class="col-lg-1">
        <img [src]="left_menu_display ? '/assets/images/icon/full-screen.svg' : '/assets/images/icon/exix-f.svg'"
          class="text-end" (click)="setFullScreen()" [title]="left_menu_display ? 'Full Screen ' : 'Exit Full Screen'"
         height="22px" />
      </div>
    </div> -->
<!-- <span>{{fullScreenDisplay}}</span> -->
    <!-- <div class="row">
      <div *ngIf="left_menu_display" class="col-lg-{{left_menu}}">
        <div class="dashboard-left">
          <div class="block-content-custom" [class.collapsed]="expand_menu">

            <i class="fa-solid {{icon}} primary-color d-flex justify-content-center fs-4" (click)="setMenu()"></i>

            <app-dashboard-menu-list [collapsed]="expand_menu" (requestToggle)="setMenu()">
            </app-dashboard-menu-list>

          </div>
        </div>
      </div>

      <div class="col-lg-{{right_body}}">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</section> -->


<section>
  <div class="container-fluid">

    <!-- Mobile Header -->
    <div class="d-lg-none d-flex justify-content-between align-items-center py-3 px-2">

      <!-- Hamburger -->
      <button class="btn border-0 shadow-none p-0" data-bs-toggle="offcanvas"
        data-bs-target="#mobileSidebar">
        <i class="fa-solid fa-bars fs-3 primary-color"></i>
      </button>

    </div>

    <!-- Mobile Offcanvas -->
    <div class="offcanvas offcanvas-start custom-sidebar" tabindex="-1" id="mobileSidebar">

      <div class="offcanvas-header border-bottom">
        <button type="button" class="btn-close" data-bs-dismiss="offcanvas"></button>
      </div>

      <div class="offcanvas-body p-0">
        <app-dashboard-menu-list></app-dashboard-menu-list>
      </div>
    </div>

    <!-- Desktop Layout -->
    <div class="row">

      <!-- Sidebar Desktop -->
      <div *ngIf="left_menu_display" class="col-lg-{{left_menu}} d-none d-lg-block">

        <div class="dashboard-left">
          <div class="block-content-custom" [class.collapsed]="expand_menu">

            <!-- Hamburger -->
            <i class="fa-solid {{icon}} primary-color d-flex justify-content-center fs-4 py-3 cursor-pointer"
              (click)="setMenu()"></i>

            <!-- Sidebar -->
            <app-dashboard-menu-list
              [collapsed]="expand_menu"
              (requestToggle)="setMenu()">
            </app-dashboard-menu-list>

          </div>
        </div>

      </div>

      <!-- Main Content -->
      <div class="col-12 col-lg-{{right_body}}">
        <router-outlet></router-outlet>
      </div>

    </div>
  </div>
</section>

<!-- <ul>
              @for (menu of menuCustom; track menu; let i = $index) {
              <li *ngIf="!menu.hideMenu">
                <div class="collection-collapse-block"  [class.open]="menu.expandMenu">
                  <h3 class="collapse-block-title" [class.active]="menu.active"
                    (click)="menu.expandMenu=!menu.expandMenu">{{menu.title}}</h3>
                  <div class="collection-collapse-block-content" >
                    <ul class="submenu">
                      @for (subMenu of menu.subMenu; track subMenu; let j=$index) {
                      <li [class.active]="subMenu.active" (click)="setActive(i,j);goTo(subMenu.link)"
                        *ngIf="subMenu.show">
                        <a href="javascript:void(0)">{{ subMenu.title }}</a>
                      </li>
                      }
                    </ul>

                  </div>
                </div>
              </li>
              }

              <li>
                <div style="margin-left: 5%; border: 0px solid green;display: flex;
                  flex-direction: column;
                  width: 100%;">
                  <h3 *ngIf="menuCustom.supportDisplay"
                    (click)="goTo('/vendor/all-vendor-tickets');deActive();supportActive=true" class="support"
                    [ngClass]="{'active': supportActive}">Support</h3>
                  <h3 style="color: #BF0000;" (click)="logout()">Logout</h3>
                 </div>
              </li>
            </ul> -->